<template>
    <div class="floating-nav-wrapper">
        <spacer />
        <div class="navigation navigation-bottom fake-height">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    import Spacer from "../../Spacer";
    export default {
        name: "floatingNavigation",
        components: {Spacer}
    }
</script>

<style scoped>

</style>